import PropTypes from "prop-types"
import styled from "styled-components"

import { arrowAfter } from "../button"

const StyledSimple = styled.div`
  text-align: center;
  margin-top: 96px;

  h3 {
    font: var(--h5);
  }

  p {
    text-align: center;
  }

  a {
    ${arrowAfter}
  }
`

const StyledPrefooter = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 0 16px;

  h2,
  h3 {
    color: var(--color-white);
    @media (min-width: 992px) {
      font-size: 2rem;
    }
  }

  p {
    font: var(--text-lg);
    max-width: 350px;
    margin: 0;
  }

  > * + * {
    margin-top: 24px;
  }

  a.button-new--secondary {
    color: var(--grey-90);

    &:hover {
      background-color: rgba(255, 255, 255, 0.8);
    }
  }

  a:last-of-type {
    text-decoration: none;
    font: var(--text-md);
    font-weight: 600;

    &:hover {
      text-decoration: underline;
    }
  }
`

const Cta = ({ children, type }) =>
  type === "simple" ? <StyledSimple>{children}</StyledSimple> : <StyledPrefooter>{children}</StyledPrefooter>

Cta.propTypes = {
  type: PropTypes.oneOf(["simple", "prefooter"]),
}

Cta.defaultProps = {
  type: "simple",
}

export default Cta
